import { useState } from 'react';
import { DATE_FORMAT_BILLING } from 'utils/date';
import moment from 'moment';
import { sendZuoraUsage } from 'api/BillingApi';
import { DatePickerWithCollapsibleCalendar } from 'ui/datePicker';
import { Button } from 'ui/button';
import { Checkmark } from 'ui/icons/action';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';

// type Props = {
//   isOpen: boolean,
//   onClose: () => void,
// };

export const RetrySendUsageModal = ({ isOpen, onClose }) => {
  const [billRunDate, setBillRunDate] = useState(null);
  const [orgId, setOrgId] = useState(null);

  const onOrgChange = (_, { value }) => setOrgId(value);
  const getOrgIdInput = () => (
    <SemanticUI.Popup
      trigger={
        <SemanticUI.Input
          name="orgId"
          type="number"
          placeholder="Org Id"
          onChange={onOrgChange}
          fluid={true}
        />
      }
      content={<div> Leave empty to run all orgs on a given day</div>}
      on="focus"
    />
  );
  const updateTrialExpiration = (date) => {
    setBillRunDate(date);
  };
  const triggerUsageRetry = () => {
    sendZuoraUsage(
      `${moment(billRunDate).format(DATE_FORMAT_BILLING)}T00:00:00.000-07:00`,
      parseInt(orgId),
    );
    onClose();
  };

  return isOpen ? (
    <Modal isModalOpen={isOpen} size={MODAL_SIZES.MEDIUM} onClose={onClose}>
      <ModalHeader>Retry Send Usage</ModalHeader>
      <ModalBody>
        <SemanticUI.Grid centered textAlign="center" columns={2}>
          <SemanticUI.Grid.Column>
            <DatePickerWithCollapsibleCalendar
              date={billRunDate}
              id="expiration-date-input"
              onDateChange={updateTrialExpiration}
              placeholder="Bill Run Date"
            />
          </SemanticUI.Grid.Column>
          <SemanticUI.Grid.Column>{getOrgIdInput()}</SemanticUI.Grid.Column>
        </SemanticUI.Grid>
      </ModalBody>
      <ModalFooter>
        <Button isDisabled={!billRunDate} onClick={triggerUsageRetry}>
          <Checkmark isColorInherited /> Retry
        </Button>
      </ModalFooter>
    </Modal>
  ) : null;
};
